<!--
 * @Description: 
 * @Autor: yd
 * @Date: 2020-07-13 09:24:52
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-02-05 15:12:50
--> 
<template>
  <div>
    <mrc_ess_iconGroup :is_disabled='readonly'
                       :showReturn='false'
                       :showEdit="hasBtn('edit-staff-handover')&&$store.state.listObj.result_status==0"
                       :show_del="hasBtn('delete-staff-handover')&&$store.state.listObj.result_status==0"
                       @handleEdit='handleEdit'
                       @handleDel='handleDel'></mrc_ess_iconGroup>
    <connect :disabled='readonly'
             @changeReadonly='handleEdit'></connect>
  </div>
</template>

<script>
import { deleteHandover } from '@/service/api/staffmsg.js'
import connect from './connect'
export default {
  components: {
    connect
  },
  props: {},
  data () {
    return {
      readonly: false,
      list: {}
    };
  },
  computed: {},
  created () { },
  watch: {
    readonly: {
      handler (v) {
        if (!this.$store.state.uuid) return
        if (!v) {
          this.$route.meta.title = 'label_edit_employee_resignation_and_transfer'
          this.$store.commit('set_page_title', 'label_edit_employee_resignation_and_transfer')
        }
        else {
          this.$route.meta.title = 'label_view_employee_resignation_and_transfer'
          this.$store.commit('set_page_title', 'label_view_employee_resignation_and_transfer')
        }
      }, immediate: true
    }
  },
  mounted () {
    this.readonly = this.$store.state.iconstatus
  },
  beforeDestroy () {

  },
  methods: {
    handleEdit () {
      this.readonly = !this.readonly
      this.$store.commit('set_iconstatus', this.readonly)
    },
    handleDel () {
      this.$myConfirm({ content: this.$t('message_Confirm_the_deletion') }).then(res => {
        deleteHandover({ uuid: this.$store.state.uuid }).then(res => {
          if (res.code == 200) {
            this.$Message({ text: this.$t('message_The_deletion_was_successful') })
            this.$router.push({
              name: 'staffConnect',
              params: {
                type: 'del'
              }
            })
          }
        })
      })
    },
  },
};
</script>

<style scoped>
</style>
